var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":_vm.width},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.profile)?_c('profile-card',{attrs:{"profile":_vm.profile}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }